import { type BaseProductElementProps } from "~/feature/Product/types";
import { useProductContext } from "~/feature/Product/ProductContext";
import { forwardRef } from "react";
import { Typography, type TypographyProps } from "@mui/material";

type Props = BaseProductElementProps & Omit<TypographyProps, "children">;

export const DesignationV2 = forwardRef<HTMLElement, Props>((props, ref) => {
  const product = useProductContext(props);

  return (
    <Typography ref={ref} {...props}>
      {product.designation}
    </Typography>
  );
});
